import type { Activity } from 'bundles/connect/types';
import React from 'react';
import { Form } from 'react-bootstrap-5';

type OtherFormProps = {
  activity: Activity;
  onUpdate: (activity: Activity) => void;
}

export default function OtherForm({ activity, onUpdate }: OtherFormProps) {
  return (
    <div className="d-flex flex-column gap-3">
      <Form.Group>
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          className="privacy-mask"
          rows={5}
          value={activity.description}
          onChange={e => onUpdate({ ...activity, description: e.target.value })}
        />
      </Form.Group>
    </div>
  );
}
